import './OrderSearchGrid.scss';
import {
    Column,
    Format
} from 'devextreme-react/data-grid';

import { useSearchOrders } from "../api/search-orders";
import { OrderSearchGridProps } from '../types/OrderSearchGridProps';
import { OrderSearchParams } from '../types/OrderSearchParams';
import { Link, useLocation } from 'react-router-dom';
import { LoadPagePanel, SyncDataGrid } from '../../../../components';
import { KindOfOrder } from '../../../../types/enums';

export default function OrderSearchGrid(props: OrderSearchGridProps) {

    let params = {} as OrderSearchParams;
    params[props.searchField as keyof OrderSearchParams] = props.searchText;

    const orders = useSearchOrders(params);

    const location = useLocation();
    const returnUrl = encodeURIComponent(location.pathname + location.search);

    function getActionRequiredUrl(order: any) {
        let url;
        let actionRequiredID = order.actionRequiredID;
        if (actionRequiredID === 111 || actionRequiredID === 112) {
            actionRequiredID = 110;
        }

        if (actionRequiredID === 121 || actionRequiredID === 122 || actionRequiredID === 126) {
            actionRequiredID = 120;
        }

        if (order.kindOfOrderID === KindOfOrder.MaterialOrder) {
            url = order.retailOrderID ?
                `/cfi/retail-order/${order.retailOrderID}/130/${order.orderID}?returnUrl=${returnUrl}` :
                `/cfi/material-order/${order.orderID}?returnUrl=${returnUrl}`;
        }
        else if (order.kindOfOrderID === KindOfOrder.WorkOrder) {
            url = `/cfi/work-order/${order.orderID}${!!actionRequiredID ? '/' + actionRequiredID : ''}?returnUrl=${returnUrl}`;
        }
        else if (order.kindOfOrderID === KindOfOrder.Estimate) {
            url = `/cfi/estimate/${order.orderID}${!!actionRequiredID ? '/' + actionRequiredID : ''}?returnUrl=${returnUrl}`;
        }
        else {
            url = `/cfi/retail-order/${order.orderID}${!!actionRequiredID ? '/' + actionRequiredID : ''}?returnUrl=${returnUrl}`;
        }

        return url;
    }

    return (
        <>
            <SyncDataGrid
                stateStorageKey={'order-search-grid-v3'}
                className={'dx-card wide-card'}
                dataSource={orders.data}
                keyExpr={['orderNumber']}
                height="68vh"
            >
                <Column
                    dataField={'orderNumber'}
                    caption={'Order #'}
                    dataType="string"
                    cellRender={(cell: any) => {
                        return <Link to={getActionRequiredUrl(cell.data)}>
                            {cell.data.orderNumber}
                        </Link>;
                    }}
                />
                <Column
                    dataField={'orderType'}
                    caption={'Order Type'}
                    dataType="string"
                />                
                <Column
                    dataField={'projectNumber'}
                    caption={'Project #'}
                    dataType="string"
                />
                <Column
                    dataField={'date'}
                    caption={'Customer Order Date'}
                    dataType="date"
                />
                <Column
                    dataField={'amount'}
                    caption={'Order Amount'}
                    dataType="number"
                    editorOptions={{ format: '$#,##0.##', showClearButton: true }}
                >
                    <Format type="currency" precision={2} ></Format>
                </Column>
                <Column
                    dataField={'orderStatus'}
                    caption={'Status'}
                    dataType="string"
                />
                <Column
                    dataField={'actionRequired'}
                    caption={'Action Required'}
                    dataType="string"
                />
                <Column
                    dataField={'dealerNumber'}
                    caption={'Store #'}
                    dataType="string"
                />
                <Column
                    dataField={'proxyStoreNumber'}
                    caption={'Proxy Store #'}
                    dataType="string"
                />
                <Column
                    dataField={'productLine'}
                    caption={'Product Line'}
                    dataType="string"
                />
                <Column
                    dataField={'customerName'}
                    caption={'Customer Name'}
                    dataType="string"
                />
                <Column
                    dataField={'customerAddress'}
                    caption={'Address'}
                    dataType="string"
                />
                <Column
                    dataField={'customerPhone'}
                    caption={'Customer Phone #'}
                    dataType="string"
                />
                <Column
                    dataField={'customerCityZip'}
                    caption={'City/State,Zip'}
                    dataType="string"
                />
            </SyncDataGrid>

            <LoadPagePanel visible={orders.isLoading} />

        </>
    )
} 
